module.exports = __webpack_public_path__ + "img/table-empty.d23b1ca2.png";